define('OutSystems/ReactWidgets/HeaderCell',["require", "exports", "tslib", "OutSystems/ClientRuntime/ObjectExtensions", "OutSystems/ClientRuntime/Settings", "OutSystems/ReactView/Widget", "prop-types", "react"], function (require, exports, tslib_1, ObjectExtensions, Settings_1, Widget_1, PropTypes, React) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.HeaderCell = void 0;
    var HeaderCell = (function (_super) {
        tslib_1.__extends(HeaderCell, _super);
        function HeaderCell() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.handleInteractive = function (event) {
                event.preventDefault();
                event.stopPropagation();
                _this.executeWithActiveClassOn(function () { return _this.onSort(_this.props.sortAttribute, _this.getDefaultSortDirection()); });
            };
            return _this;
        }
        HeaderCell_1 = HeaderCell;
        Object.defineProperty(HeaderCell.prototype, "onSort", {
            get: function () {
                return this.context.onTableRecordsSort;
            },
            enumerable: false,
            configurable: true
        });
        HeaderCell.prototype.getDefaultSortDirection = function () {
            var _a;
            var value = (_a = this.props.extendedProperties) === null || _a === void 0 ? void 0 : _a[HeaderCell_1.DefaultSortDirectionProperty];
            return value === "descending" ? "descending" : "ascending";
        };
        HeaderCell.prototype.getSortDirection = function () {
            if (!(0, Settings_1.getEnvParams)().EnableWCAG22 || !this.props.sortAttribute) {
                return undefined;
            }
            var headerCellContext = this.context;
            if (this.props.sortAttribute === (headerCellContext === null || headerCellContext === void 0 ? void 0 : headerCellContext.tableRecordsCurrentSortAttribute)) {
                return headerCellContext.tableRecordsCurrentSortDirection;
            }
            return "none";
        };
        HeaderCell.prototype.shouldComponentUpdate = function (nextProps, nextState, nextContext) {
            var currentContext = this.context;
            var isCurrentlySortedColumn = !!this.props.sortAttribute && this.props.sortAttribute === currentContext.tableRecordsCurrentSortAttribute;
            var willBeSortedColumn = !!nextProps.sortAttribute && nextProps.sortAttribute === nextContext.tableRecordsCurrentSortAttribute;
            var shouldCompareSortDirection = isCurrentlySortedColumn || willBeSortedColumn;
            return (currentContext.tableRecordsCurrentSortAttribute !== nextContext.tableRecordsCurrentSortAttribute ||
                (shouldCompareSortDirection &&
                    currentContext.tableRecordsCurrentSortDirection !== nextContext.tableRecordsCurrentSortDirection) ||
                _super.prototype.shouldComponentUpdate.call(this, nextProps, nextState, nextContext));
        };
        HeaderCell.prototype.render = function () {
            var _this = this;
            var className = this.props.style || "";
            var sortDiv;
            var sortDivAttributes = {
                className: "sortable-icon",
            };
            if (this.props.style !== "sortable" && this.props.sortAttribute) {
                className += " sortable";
                sortDiv = React.createElement("div", tslib_1.__assign({}, sortDivAttributes));
            }
            var headerCellContext = this.context;
            if (this.props.style !== "sorted" &&
                headerCellContext &&
                this.props.sortAttribute &&
                this.props.sortAttribute === headerCellContext.tableRecordsCurrentSortAttribute) {
                className += " sorted";
            }
            className = className.trim();
            var headerCellAttributes = {
                className: className,
                tabIndex: 0,
                "aria-sort": this.getSortDirection(),
            };
            if (this.onSort && this.props.sortAttribute) {
                var enterKeyCode_1 = 13;
                headerCellAttributes.onClick = this.handleInteractive;
                headerCellAttributes.onKeyDown = function (event) { return event.keyCode === enterKeyCode_1 && _this.handleInteractive(event); };
            }
            this.fillWithBuiltinProperties(headerCellAttributes);
            return (React.createElement("th", tslib_1.__assign({}, headerCellAttributes),
                this.props.children,
                sortDiv));
        };
        var HeaderCell_1;
        HeaderCell.DefaultSortDirectionProperty = "default-sort-direction";
        HeaderCell.contextTypes = ObjectExtensions.assign({
            onTableRecordsSort: PropTypes.func,
            tableRecordsCurrentSortAttribute: PropTypes.string,
            tableRecordsCurrentSortDirection: PropTypes.string,
        }, Widget_1.Widget.contextTypes);
        HeaderCell = HeaderCell_1 = tslib_1.__decorate([
            Widget_1.WidgetSpec
        ], HeaderCell);
        return HeaderCell;
    }(Widget_1.Widget));
    exports.HeaderCell = HeaderCell;
});
//# sourceMappingURL=HeaderCell.js.map;
